import React from 'react';
import { Link } from 'react-router-dom';
import './Imprint.css';

function Imprint() {
  return (
    <div className="imprint">
      <Link to="/" className="back-to-home">← Back to Home</Link>
      <div className="imprint-container">
        <header className="imprint-header">
          <h1 className="imprint-title">Imprint</h1>
          <p className="imprint-subtitle">Legal Information</p>
        </header>

        <div className="imprint-content">
          <section className="imprint-section">
            <h2>Company Information</h2>
            <div className="imprint-text">
              <p><strong>Orient Analytics Inc</strong></p>
              <p>Music Catalog Analysis & Revenue Optimization Services</p>
              <p>Registered Office: Delaware, United States</p>
            </div>
          </section>

          <section className="imprint-section">
            <h2>Contact Information</h2>
            <div className="imprint-text">
              <p><strong>Address:</strong></p>
              <p>Orient Analytics Inc</p>
              <p>2093 PHILADELPHIA PIKE #3910</p>
              <p>CLAYMONT, DE 19703</p>
              <p>UNITED STATES</p>
              <br />
              <p><strong>Contact:</strong></p>
              <p>Email: <a href="mailto:hey@orientanalytics.com">hey@orientanalytics.com</a></p>
              <p>Phone: <a href="tel:+13025551234">+1 (302) 555-1234</a></p>
              <p>Website: <a href="https://songaudit.com">www.songaudit.com</a></p>
            </div>
          </section>

          <section className="imprint-section">
            <h2>Responsible for Content</h2>
            <div className="imprint-text">
              <p><strong>Chief Executive Officer:</strong></p>
              <p>Abdullah Tim</p>
              <p>Orient Analytics Inc</p>
              <p>2093 PHILADELPHIA PIKE #3910</p>
              <p>CLAYMONT, DE 19703, UNITED STATES</p>
            </div>
          </section>

          <section className="imprint-section">
            <h2>Professional Information</h2>
            <div className="imprint-text">
              <p><strong>Business Activity:</strong> Music Analytics & Revenue Optimization Services</p>
              <p><strong>Industry Classification:</strong> Data Analytics & Music Technology</p>
              <p><strong>Regulatory Authority:</strong> Delaware Division of Corporations</p>
              <p><strong>Business Regulations:</strong> Delaware General Corporation Law</p>
            </div>
          </section>

          <section className="imprint-section">
            <h2>Disclaimer</h2>
            <div className="imprint-text">
              <p>The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents' accuracy, completeness or topicality. According to statutory provisions, we are furthermore responsible for our own content on these web pages.</p>
              
              <p>As service providers, we are not under obligation to monitor merely the third party information provided or stored on our website. Once we have become aware of a specific infringement of the law, we will immediately remove the content in question.</p>
              
              <p>Our offer contains links to external third party websites. We have no influence on the contents of those websites, therefore we cannot guarantee for those contents. Providers or administrators of linked websites are always responsible for the contents of the linked websites.</p>
            </div>
          </section>

          <section className="imprint-section">
            <h2>Copyright</h2>
            <div className="imprint-text">
              <p>The content and works on these pages created by the site operators are subject to US copyright law. Duplication, processing, distribution, or any form of commercialization of such material beyond the scope of the copyright law shall require the prior written consent of its respective author or creator.</p>
              
              <p>© 2025 Orient Analytics Inc - Song Audit Platform. All rights reserved.</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Imprint; 